import React from "react";

// const brands = [
//   "JAAR FASHION",
//   "Adidas",
//   "Nike",
//   "Puma",
//   "Bamboo",
//   "Canin",
//   "Delibop",
//   "Emburo"
// ];

const BrandFilter = ({ brandCounts = {}, filters, setFilters }) => {
  const brands = Object.keys(brandCounts);

  const toggle = (brand) => {
    setFilters((prev) => ({
      ...prev,
      brands: prev.brands.includes(brand)
        ? prev.brands.filter((b) => b !== brand)
        : [...prev.brands, brand]
    }));
  };

  if (!brands.length) return null;

  return (
    <div>
      <h4 className="font-medium mb-2">Brands</h4>
      <div className="space-y-2 max-h-40 overflow-y-auto pr-1">
        {/* {Object.keys(brandCounts).map((brand) => (
          <label
            key={brand}
            className="flex items-center gap-2 text-sm cursor-pointer"
          >
            <input
              type="checkbox"
              checked={filters.brands.includes(brand)}
              onChange={() => toggle(brand)}
            />
            {brand}
          </label>
        ))} */}
        {brands.map((brand) => {
          const count = brandCounts[brand];
          const disabled = count === 0;

          return (
            <label
              key={brand}
              className={`flex items-center gap-2 text-sm
                ${disabled ? "text-gray-400 cursor-not-allowed" : "cursor-pointer"}
              `}
            >
              <input
                type="checkbox"
                disabled={disabled}
                checked={filters.brands.includes(brand)}
                onChange={() => toggle(brand)}
              />

              <span>
                {brand}{" "}
                <span className="text-xs text-gray-500">
                  ({count})
                </span>
              </span>
            </label>
          );
        })}
      </div>
    </div>
  );
};

export default BrandFilter;
